import React, { useEffect, useState, useRef } from 'react';
import PropTypes from "prop-types";
import RutFactory from 'factories/Rut';
import style from './style.scss'; //NOSONAR

let timeout = {};
const InputRut = (props) => {
    const [rutIsValid, setRutIsValid] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    let rutMessage = props.errorMessageValue ? props.errorMessageValue : "Ingrese un RUT válido";
    const inputRut = useRef();
    const callbackisValid = props.callbackisValid ? props.callbackisValid : () => {};
    const {label, placeholder} = props;

    useEffect(() => {
        if (props && props.defaultRut) {
            setRutIsValid(validateRut(props.defaultRut));
            callbackisValid(validateRut(props.defaultRut), props.defaultRut);
        } else {
            setRutIsValid(false);
        }
        return function cleanup() {
            timeout[name] = null;
        }
    }, [props.defaultRut]);

    const _onChangeRut = (event) => {
        let value = event.trim().replace(/(\.|-)/g, '');
        const rutValid = validateRut(value);
        setShowMessage(false);
        setRutIsValid(rutValid);
        inputRut.current.value = formatRut(value);
        callbackisValid(validateRut(value), value);

        if(!timeout[name]) timeout[name] = null;

        clearTimeout(timeout[name]);
        if(rutValid){
            setShowMessage(false);
        }else{
            timeout[name] = setTimeout(()=>{
                setShowMessage(true)
            },1000);
        }
    }

    const validateRut = (value) => {
        if(!value) return false;
        return RutFactory.validateRut(value);
    }



    const formatRut = (rut) => {
        let rutIn = rut ? rut.replace(/^0+/, "") : "";
        let rutFormat = "";
        if (rutIn !== '' && rutIn.length) {
            let withoutPoints = rutIn.replace(/\./g, "");
            let rutClean = withoutPoints.replace(/-/g, "");
            let start = rutClean.substring(0, rutClean.length - 1);

            let i = 0;
            let j = 1;
            for (i = start.length - 1; i >= 0; i--) {
                let letra = start.charAt(i);
                rutFormat = letra + rutFormat;
                if (j % 3 == 0 && j <= start.length - 1) {
                    rutFormat = "." + rutFormat;
                }
                j++;
            }
            let dv = rutClean.substring(rutClean.length - 1);
            rutFormat = rutFormat + "-" + dv;
        }
        return rutFormat;
    }

    return (
        <div className={'input-rut-wrap ' + (!rutIsValid && showMessage ? 'is-rut-error' : '')}>
            {label && <label className="title-label">
                {label}
            </label>}
            <input type="text" ref={inputRut} className={'item-rut-number' + ((props.defaultRut) ? ' disabled' : '')} placeholder={ placeholder ? placeholder : 'Rut' } defaultValue={formatRut(props.defaultRut)} onChange={ev => _onChangeRut(ev.target.value)} onBlur={ev => _onChangeRut(ev.target.value)} maxLength={12} disabled={(props && props.defaultRut) ? true : false}/>
            {rutIsValid && <i className="font-icn check-rounded"></i>}
            <p className='error-message-rut'>
                {rutMessage}
            </p>
        </div>
    )
};

InputRut.propTypes = {
    callbackisValid: PropTypes.func,
    defaultRut: PropTypes.string,
    errorMessageValue: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string
};

export default InputRut;
